import { CircularProgress, Button as MdButton, ButtonProps as MdButtonProps } from '@mui/material';

export interface ButtonProps extends MdButtonProps {
  title?: string;
  busy?: boolean;
  target?: '_blank' | '_self' | '_parent' | '_top' | string;
  children?: React.ReactNode;
}

export const Button = ({ busy, children, startIcon = null, ...rest }: ButtonProps) => {
  const startIconOrSpinner = busy ? (
    <CircularProgress size={16} thickness={12} color='inherit' />
  ) : (
    startIcon
  );
  return (
    <MdButton {...rest} startIcon={startIconOrSpinner}>
      {children}
    </MdButton>
  );
};
